import {setInitialState} from '../../../../utils/reducerOperations';

export const InitialState=()=>({
    fetchExploreTrendInsightsDataApi:setInitialState(),
    isTrendInsightsAlreadyFetched:false,
    filters:{},
    selectedUser : "",
    directReporteesOnly: false
});